import { ChildProps } from '@apollo/client/react/hoc';
// TODO update this to import from commons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import I18n from 'i18n-js';
import classNames from 'classnames';
import { WithRouterProps, withRouter } from 'react-router';

import Item2FeedbackList from './item2_feedback_list';
import FeedbackSummary from './discovery/feedback_summary';
import { Item2FeedbackMetadata, core_apimessages_Feedback_Type } from '@reverbdotcom/commons/src/gql/graphql';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';

import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { connect } from '@reverbdotcom/commons/src/connect';

interface ExternalProps {
  sellerUuid: string;
  feedbackSummaryData: FeedbackSummary;
}

type IProps = ChildProps<ExternalProps & WithRouterProps, Item2FeedbackMetadata.Query, Location>;

function FeedbackSummaryTable(props) {
  if (!props.feedbackSummaryData) return null;

  const { feedbackSummaryData } = props;

  return (
    <div className="feedback-summary-table">
      <div className="weight-bold align-center mb-4">
        {I18n.t('discovery.shop.feedbackSummary.title')}
      </div>
      <table>
        <thead>
          <tr>
            <th />
            <th>{I18n.t('discovery.shop.feedbackSummary.sixMonths')}</th>
            <th>{I18n.t('discovery.shop.feedbackSummary.twelveMonths')}</th>
            <th>{I18n.t('discovery.shop.feedbackSummary.lifetime')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{I18n.t('discovery.shop.feedbackSummary.positive')}</td>
            <td>{feedbackSummaryData.positive_percent.recent}%</td>
            <td>{feedbackSummaryData.positive_percent.middle}%</td>
            <td>{feedbackSummaryData.positive_percent.all_time}%</td>
          </tr>
          <tr>
            <td>{I18n.t('discovery.shop.feedbackSummary.negative')}</td>
            <td>{feedbackSummaryData.negative_percent.recent}%</td>
            <td>{feedbackSummaryData.negative_percent.middle}%</td>
            <td>{feedbackSummaryData.negative_percent.all_time}%</td>
          </tr>
          <tr>
            <td>{I18n.t('discovery.shop.feedbackSummary.count')}</td>
            <td>{feedbackSummaryData.counts.recent}</td>
            <td>{feedbackSummaryData.counts.middle}</td>
            <td>{feedbackSummaryData.counts.all_time}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

function getFilterTypeFromURL(props: IProps) {
  const { BUYER, SELLER, RECEIVED } = core_apimessages_Feedback_Type;
  const urlParams = new URLSearchParams(props.location.search);

  if (urlParams.get('filter') === 'seller') return SELLER;
  if (urlParams.get('filter') === 'buyer') return BUYER;

  return RECEIVED;
}

export function Item2Feedback(props: IProps) {
  const { BUYER, SELLER, RECEIVED } = core_apimessages_Feedback_Type;

  if (props.data.loading || !props.data.user) return null;

  const { allTotal, sellerTotal, buyerTotal } = props.data.user;
  const filterType = getFilterTypeFromURL(props);

  return (
    <>
      <FeedbackSummaryTable
        feedbackSummaryData={props.feedbackSummaryData}
      />
      <div className="mtb-4 button-group" data-i2-feedback-filters>
        <CoreLink
          to={{
            query: {
              page: 1,
              filter: 'all',
            },
            anchor: 'shop-reviews',
          }}
          className={
            classNames(
              'button-group__button',
              { 'button-group__button--selected': (filterType === RECEIVED) },
            )
          }
        >
          {I18n.t('discovery.item2Feedback.filters.all',
            { count: allTotal.total },
          )}
        </CoreLink>
        <CoreLink
          to={{
            query: {
              page: 1,
              filter: 'seller',
            },
            anchor: 'shop-reviews',
          }}
          className={
            classNames(
              'button-group__button',
              { 'button-group__button--selected': (filterType === SELLER) },
            )
          }
        >
          {I18n.t('discovery.item2Feedback.filters.seller',
            { count: sellerTotal.total })}
        </CoreLink>
        <CoreLink
          to={{
            query: {
              page: 1,
              filter: 'buyer',
            },
            anchor: 'shop-reviews',
          }}
          className={
            classNames(
              'button-group__button',
              { 'button-group__button--selected': (filterType === BUYER) },
            )
          }
        >
          {I18n.t('discovery.item2Feedback.filters.buyer',
            { count: buyerTotal.total })}
        </CoreLink>
      </div>
      <Item2FeedbackList
        sellerUuid={props.sellerUuid}
        type={filterType}
      />
    </>
  );
}

const withQuery = withGraphql<IProps, Item2FeedbackMetadata.Query>(
  gql`
    query Item2_Feedback_Metadata(
      $sellerUuid: String
    ){
      user(input: { uuid: $sellerUuid }) {
        _id
        allTotal: feedback(input: { type: RECEIVED }) {
          total
        }
        buyerTotal: feedback(input: { type: BUYER }) {
          total
        }
        sellerTotal: feedback(input: { type: SELLER }) {
          total
        }
      }
    }
  `,
  {
    options: (ownProps) => {
      return {
        ssr: false,
        errorPolicy: 'all',
        variables: {
          sellerUuid: ownProps.sellerUuid,
        },
      };
    },
  },
);

export default connect<ExternalProps>([
  withQuery,
  withRouter,
])(Item2Feedback);
